module.exports = __webpack_public_path__ + "static/media/a3.5fd5f8ed.jpg";